<template>
  <div>
    <b-form-group label-for="idnamespace">
      <b-input-group id="idnamespace">
        <template #prepend>
          <b-form-select
            v-model="namespace"
            :options="storenamespaces"
          ></b-form-select>
        </template>
        <b-form-select
          id="idstorevar"
          ref="idstorevar"
          v-model="storeVar"
          :options="namespacegetters.sort()"
        ></b-form-select>
        <b-form-input v-model="storePar" v-if="isStoreFunction"></b-form-input>
        <!-- <b-form-input list="idstorevar" v-model="storeVar"></b-form-input>
        <datalist id="idstorevar">
          <option v-for="store in namespacegetters.sort()" :key="store">
            {{ store }}
          </option>
        </datalist> -->
      </b-input-group>
      <div class="jumbotron mt-2 p-4">
        <div v-if="getstore">
          <json-viewer :value="getstore" :expand-depth="5" copyable boxed sort>
          </json-viewer>
        </div>
        <div v-else>
          <pre>Variável não encontrada</pre>
        </div>
      </div>
    </b-form-group>
    <!-- namespace: {{ namespace }}<br />
      getstore: {{ getstore }} 
      storeVar: {{ storeVar }}<br />
    -->
  </div>
</template>

<script>
import state from "../stores";
export default {
  name: "VuexInspect",
  props: {
    namespaces: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      storeVar: "",
      storePar: null,
      namespace: "Namespace",
    };
  },
  computed: {
    storenamespaces() {
      return ["Namespace", ...this.namespaces].sort();
    },
    resolvegettername() {
      return this.namespace !== "Namespace"
        ? `${this.namespace}/${this.storeVar}`
        : this.storeVar;
    },
    isStoreFunction() {
      return state.getters[this.resolvegettername] instanceof Function;
    },
    getstore() {
      return this.isStoreFunction
        ? state.getters[this.resolvegettername](this.storePar)
        : state.getters[this.resolvegettername];
    },
    namespacegetters() {
      return this.namespace !== "Namespace"
        ? Object.keys(state.getters)
            .filter((f) => f.includes(this.namespace))
            .map((m) => m.replace(`${this.namespace}/`, ""))
        : Object.keys(state.getters);
    },
  },

  methods: {
    doInputFocus() {
      this.$refs.idstorevar.focus();
    },
  },
};
</script>
